export default __webpack_public_path__ + "static/media/trial-form-image.fd219bfc.png";